import script from "./forgotPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./forgotPassword.vue?vue&type=script&setup=true&lang=js"

import "./forgotPassword.vue?vue&type=style&index=0&id=43e51b07&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43e51b07"]])

export default __exports__